import { Link } from 'react-router';

export function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-bg)] px-4">
      <div className="bg-[var(--color-surface)] border border-[var(--color-border)] rounded-lg shadow-sm p-10 max-w-md w-full text-center">
        <h1 className="text-2xl font-bold text-[var(--color-ink)]">Page not found</h1>
        <p className="mt-2 text-sm text-[var(--color-ink-2)]">
          We couldn&apos;t find what you&apos;re looking for. If you followed a link
          from your project manager, double-check the URL or ask them to resend it.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block text-sm text-[var(--color-accent)] hover:underline"
        >
          Back to portal home
        </Link>
      </div>
    </div>
  );
}
